/*=============================================== FajnyIcon ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Mixins from "./Mixins";
import SvgSprite from "../icon-sprite.svg";
/*==================== Component ====================*/
var FajnyIcon = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "currentColor" : _b, name = _a.name, _c = _a.size, size = _c === void 0 ? 24 : _c, props = __rest(_a, ["color", "name", "size"]);
    return (React.createElement(Container, __assign({ "$color": color, "$size": size }, props),
        React.createElement("use", { xlinkHref: "".concat(SvgSprite, "#").concat(name) })));
};
export default FajnyIcon;
/*==================== Styles ====================*/
var Container = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n"], ["\n    width: ", "px;\n    height: ", "px;\n    color: ", ";\n"])), function (_a) {
    var $size = _a.$size;
    return $size;
}, function (_a) {
    var $size = _a.$size;
    return $size;
}, Mixins.AllColors);
var templateObject_1;
